import { useSelector } from 'react-redux';
import type { RootState } from '../store';

export const useSelectedCategories = () => {
  return useSelector((state: RootState) => state.category.activeCategories);
};
